import AC from "components/Stacker/constants/ApplicationConstants"

import ApiUtils from "components/Stacker/api"

export const enableSPA = () => {
  return {
    type: AC.SPA_ENABLED,
  }
}

export const setStystemError = () => {
  return {
    type: AC.SYSTEM_ERROR_OCCURED,
  }
}

export const clearStystemError = () => {
  return {
    type: AC.SYSTEM_ERROR_CLEARED,
  }
}

export const setRedirectUrl = (args) => {
  const { url, pid = null } = args
  return {
    type: AC.SET_REDIRECT_URL,
    payload: { url, pid },
  }
}

export const clearRedirectUrl = () => {
  return {
    type: AC.CLEAR_REDIRECT_URL,
  }
}

export const getCSRFToken = (getNewToken) => (dispatch, getState) => {
  const currentCSRFToken = getState().application.csrfToken
  if (getNewToken || !currentCSRFToken) {
    // ApiUtils.makeAjaxRequest(
    // 	{
    // 		url: '/libs/granite/csrf/token.json',
    // 		method: ApiUtils.METHOD_GET,
    // 		isRootUrl: true
    // 	},
    // 	res => {
    // 		dispatch({
    // 			type: AC.CSRF_TOKEN_SET,
    // 			payload: res.token
    // 		});
    // 	}
    // );
    window.setTimeout(() =>
      dispatch({ type: AC.CSRF_TOKEN_SET, payload: "SHIM_TOKEN" })
    )
  }
}

export const setPreviousHistory = (payload) => {
  return {
    type: AC.SET_PREVIOUS_HISTORY,
    payload,
  }
}
